/**
 * @fileoverview which user-management controls a developer may use
 */

import type { DashboardUserPermissionChecks } from "./types";

/**
 * Whether a developer of a regular (non-free-trial) company may open user management.
 * Edit Dashboard Users and Delete Dashboard Users both qualify.
 */
export const canAccessDashboardUserManagement = ({
  hasPermissionForAnyScope,
}: DashboardUserPermissionChecks): boolean =>
  hasPermissionForAnyScope("editDashboardUsers") || hasPermissionForAnyScope("deleteDashboardUsers");

/**
 * Whether the add and edit controls inside user management show.
 */
export const canEditDashboardUsers = ({ hasPermissionForAnyScope }: DashboardUserPermissionChecks): boolean =>
  hasPermissionForAnyScope("editDashboardUsers");

/**
 * Whether the delete controls for a regular (non-free-trial) developer show.
 * Delete Dashboard Users is company-scoped, and company admins hold it implicitly.
 */
export const canDeleteDashboardUsers = ({ hasPermissionForAnyScope }: DashboardUserPermissionChecks): boolean =>
  hasPermissionForAnyScope("deleteDashboardUsers");
